import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Signup from "./Components/Signup";
import Login from "./Components/Login";
import Home from "./Components/Home";
import CreatePassword from "./Components/CreatePassword";
import ForgotPassword from "./Components/ForgotPassword";
import ConfirmCreatePassword from "./Components/ConfirmCreatePassword";
import ConfirmSignup from "./Components/ConfirmSignup";
import ErrorBoundary from "./Components/ErrorBoundary";
import PrivateRoute from "./Components/PrivateRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VerifyOTP from "./Components/VerifyOTP";

const Dashboard = lazy(() => import("./Components/Dashboard"));
const AdminDashboard = lazy(() => import("./Admin/Dashboard"));

const App = () => {
  return (
    <Router>
      <ErrorBoundary>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
        />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="" element={<Home />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verifyotp" element={<VerifyOTP />} />
            <Route path="/confirm-signup" element={<ConfirmSignup />} />
            <Route path="/signup/:role/:id" element={<CreatePassword />} />
            <Route path="/reset-password/:id" element={<CreatePassword />} />
            <Route
              path="/password-confirmation"
              element={<ConfirmCreatePassword />}
            />
            <Route path="/forgotpassword" element={<ForgotPassword />} />

            <Route path="/login" element={<Login />} />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute allowedRoles={["client_admin", "client_user"]}>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <PrivateRoute
                  allowedRoles={["super_admin", "site_admin", "operator"]}
                >
                  <AdminDashboard />
                </PrivateRoute>
              }
            />

            <Route path="" element={<Navigate to="/signup" />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
};

export default App;
